import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { Link, Outlet } from 'react-router-dom';
import { useAppStoreSelector } from '../../../../store';
import { findIcon } from '../../../../utils/iconFinder';
import Copyright from '../../../app/components/Copyright';
import { selectIsGuestMode } from '../../../portal/store';
import styles from '../../Auth.module.scss';
import { useTranslation } from 'react-i18next';

function DoubleSideAuthStructure({
  isRight = true,
  image,
}: {
  isRight?: boolean;
  image: string | null;
}) {
  const isGuest = useAppStoreSelector(selectIsGuestMode);
  const { t } = useTranslation();

  return (
    <Box 
      component="main" 
      className="ps"
      sx={{
        display: 'flex',
        height: '100vh',
        flexDirection: isRight ? 'row' : 'row-reverse',
      }}
    >
      {image ? (
        <Box
          className={styles.image}
          sx={{ 
            flex: '0 0 58.333%',
            padding: 0,
            '@media (max-width: 900px)': { flex: '0 0 33.333%' }
          }}
        >
          <img
            src={image}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            alt="Auth background"
          />
        </Box>
      ) : (
        <Box 
          className={styles.image} 
          sx={{ 
            flex: '0 0 58.333%',
            '@media (max-width: 900px)': { flex: '0 0 33.333%' }
          }} 
        />
      )}

      <Box
        sx={{
          flex: '0 0 41.667%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          '@media (max-width: 900px)': { flex: '0 0 66.667%' },
          '@media (max-width: 600px)': { flex: '0 0 100%' }
        }}
      >
        <Box className={styles.paper}>
          <Box className={styles['lock-badge']}>
            <FontAwesomeIcon icon={findIcon('fas', 'lock')} />
          </Box>
          <Outlet />
          <Box>
            <Copyright />
          </Box>
          <Box>
            {isGuest && (
              <Link to="/">
                <Button variant="outlined" color="primary">
                  {t('auth.visitGuestModeButton')}
                </Button>
              </Link>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default DoubleSideAuthStructure;
